<template>
  <div class="screen">
    <div class="screenBox">
      <div :class="{'form-group': cityClick,'form-group white': !cityClick }">
        <label class="van-col--8">选择城市：</label>
        <div class="van-col--16">
          <input
              type="text"
              v-model="city"
              placeholder="请选择城市"
              readonly
              @click="cityClick ? '' : cityShow=true "
          />
        </div>
      </div>
      <div :class="{'form-group': districtClick,'form-group white': !districtClick }">
        <label class="van-col--8">选择区县：</label>
        <div class="van-col--16">
          <input
              type="text"
              v-model="district"
              placeholder="请选择区县"
              readonly
              @click="districtClick ? '' : districtShow=true"
          />
        </div>
      </div>
      <div :class="{'form-group': subdistrictClick,'form-group white': !subdistrictClick }">
        <label class="van-col--8">选择街道：</label>
        <div class="van-col--16">
          <input
              type="text"
              v-model="subdistrict"
              placeholder="请选择街道"
              readonly
              @click="subdistrictClick ? '' : subdistrictShow=true"
          />
        </div>
      </div>
      <div class="submit">
        <van-button type="info" @click="channel">重 置</van-button>
        <van-button type="primary" @click="sub">确 认</van-button>
      </div>
    </div>

    <!-- 城市 -->
    <van-popup :close-on-popstate="true" v-model="cityShow" position="bottom" :overlay="false">
      <van-picker
          show-toolbar
          :columns="cityList"
          @confirm="cityConfirm"
          @cancel="cityShow=false"/>
    </van-popup>

    <!-- 区县 -->
    <van-popup :close-on-popstate="true" v-model="districtShow" position="bottom" :overlay="false">
      <van-picker
          show-toolbar
          :columns="districtList"
          @confirm="districtConfirm"
          @cancel="districtShow=false"
      />
    </van-popup>

    <!-- 街道 -->
    <van-popup :close-on-popstate="true" v-model="subdistrictShow" position="bottom" :overlay="false">
      <van-picker
          show-toolbar
          :columns="subdistrictList"
          @confirm="subdistrictConfirm"
          @cancel="subdistrictShow=false"
      />
    </van-popup>
  </div>
</template>

<script>
import {getAreasByParAreaCode} from '@/api/dictionary';
import {printAreaCode} from '@/utils/baseUrl';

export default {
  name: "screen",
  props: [' areaCodeCity', 'areaCodeDistrict', 'areaCodeSubdistrict'],
  data() {
    return {
      city: '',
      cityId: this.$store.state.areaCodeCity || '',
      cityList: [],
      cityShow: false,
      district: '',
      districtId: this.$store.state.areaCodeDistrict || '',
      districtList: [],
      districtShow: false,
      subdistrict: '',
      subdistrictId: this.$store.state.areaCodeSubdistrict || '',
      subdistrictList: [],
      subdistrictShow: false,
      cityClick: false,
      districtClick: false,
      subdistrictClick: false
    }
  },
  watch: {
    // areaCodeCity (newValue) {
    //   if (newValue) {
    //     this.getAreaCode(printAreaCode, 0, newValue);
    //   }
    // },
    // areaCodeDistrict (newValue) {
    //   if (newValue) {
    //     this.getAreaCode(this.areaCodeCity, 1, newValue);
    //   }
    // },
    // areaCodeSubdistrict (newValue) {
    //   if (newValue) {
    //     this.getAreaCode(this.areaCodeDistrict, 2, newValue);
    //   }
    // },
  },
  created() {


  },
  mounted() {
    let cityId = this.cityId || '';
    if (!cityId) {
      this.getAreaCode(printAreaCode, 0);
    } else {
      this.getAreaCode(printAreaCode, 0, cityId);
    }
    let districtId = this.districtId || '';
    if (districtId) {
      this.getAreaCode(cityId, 1, districtId);
    }
    let subdistrictId = this.subdistrictId || '';
    if (subdistrictId) {
      this.getAreaCode(districtId, 2, subdistrictId);
    }
  },
  methods: {
    onKeyDown(keyCode){
      let handle = false
      if (this.cityShow){
        handle = true
        this.cityShow = false
      }
      if (this.districtShow){
        handle = true
        this.districtShow = false
      }
      if (this.subdistrictShow){
        handle = true
        this.subdistrictShow = false
      }
      return handle
    },
    getAreaCode(code, index, showCode) {
      if (!code) return
      let _this = this;
      getAreasByParAreaCode({
        areaCode: code,
      }).then((res) => {
        if (res.state === 'Y') { // 获取地区
          let list = res.data;
          if (index === 0) { // 获取城市改变
            _this.districtList = [];
            _this.subdistrictList = [];
            _this.cityList.push({text: '', value: ''}, ...list.map(v => {
              return {
                text: v.areaName,
                value: v.areaCode
              }
            }));
            if (showCode) {
              let showName = _this.cityList.find((v) => {
                return v.value === showCode
              });
              _this.city = showName.text;
              _this.cityId = showCode;
              _this.cityClick = true;
              _this.getAreaCode(showCode, 1, _this.districtId);
            }
          }
          if (index === 1) { // 城市改变 -> 获取区县
            _this.subdistrictList = [];
            _this.districtList.push({text: '', value: ''}, ...list.map(v => {
              return {
                text: v.areaName,
                value: v.areaCode
              }
            }))
            if (showCode) {
              let showName = _this.districtList.find((v) => {
                return v.value === showCode
              });
              _this.district = showName.text;
              _this.districtId = showCode;
              _this.districtClick = true;
              _this.getAreaCode(showCode, 2, _this.subdistrictId);
            }
          }
          if (index === 2) { // 区县改变 -> 获取街道
            _this.subdistrictList.push({text: '', value: ''}, ...list.map(v => {
              return {
                text: v.areaName,
                value: v.areaCode
              }
            }))
            if (showCode) {
              let showName = _this.subdistrictList.find((v) => {
                return v.value === showCode
              });
              _this.subdistrict = showName.text;
              _this.subdistrictId = showCode;
              _this.subdistrictClick = true;
            }
          }
          list = null;
        } else {
          this.$toast(res.msg);
          return false
        }
      })
          .catch((err) => {
            this.$toast(err);
            return false
          });
    },
    cityConfirm(data) { // 城市
      this.district = '';
      this.districtId = '';
      this.districtList = [];
      this.subdistrict = '';
      this.subdistrictId = '';
      this.subdistrictList = [];
      this.getAreaCode(data.value, 1, false); // 获取区县
      this.city = data.text;
      this.cityId = data.value;
      this.cityShow = false;
    },
    districtConfirm(data) { // 区县
      this.subdistrict = '';
      this.subdistrictId = '';
      this.subdistrictList = [];
      this.getAreaCode(data.value, 2, false); // 获取街道
      this.district = data.text;
      this.districtId = data.value;
      this.districtShow = false;
    },
    subdistrictConfirm(data) { // 街道
      this.subdistrict = data.text;
      this.subdistrictId = data.value;
      this.subdistrictShow = false;
    },
    channel() {
      if (!this.$store.state.areaCodeCity) {
        this.city = '';
        this.cityId = '';
      }
      if (!this.$store.state.areaCodeDistrict) {
        this.district = '';
        this.districtId = '';
        this.districtList = [];
      }
      if (!this.$store.state.areaCodeSubdistrict) {
        this.subdistrict = '';
        this.subdistrictId = '';
        this.subdistrictList = [];
      }

      this.cityShow = false;
      this.districtShow = false;
      this.subdistrictShow = false;
      this.$emit('changeAreaCode', {});
    },
    sub() {
      let code = {
        city:  this.cityId,
        district:  this.districtId,
        subdistrict:  this.subdistrictId,
        cityName:  this.city,
        districtName:  this.district,
        subdistrictName:  this.subdistrict,
      };
      this.$emit('changeAreaCode', code);
      this.cityShow = false;
      this.districtShow = false;
      this.subdistrictShow = false;
    }
  },
  components: {}
}
</script>

<style lang="stylus" scoped>
.screen {
  height: 100%;
  width: 100%;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;

  .form-group {
    padding: 2vmin 2vmin 2vmin 0;
    height: 10vmin;
    display: flex;
    line-height: 10vmin;
    font-size: 4vmin;
    overflow: hidden;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }

    &.noBorder {
      border: none;
    }

    label {
      text-align: left;
      text-indent: 6vmin;
      display: block;
    }

    input {
      width: 100%;
      height: 100%;
      padding: 0 3vmin;
      font-size: 4vmin;
      border: none;
      vertical-align: middle;
    }
  }

  .form-group.white {
    input {
      background: #fff;
    }
  }

  .screenBox {
    .submit {
      margin-top: 5vw;
      height: 10vw;

      button {
        height: 100%;
        width: 50%;
        margin: 0;
        font-size: 4vw;
        line-height: inherit;
      }
    }
  }
}
</style>
